// Thin wrapper around PostHog (initialised in public/index.html). Safe no-op if absent.
export function track(event, props = {}) {
  try {
    if (typeof window !== "undefined" && window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(event, props);
    }
  } catch (e) {
    /* never let analytics break the UI */
  }
}
